// External
import React from 'react';
import PropTypes from 'prop-types';

// Internal
import { ModalRoot } from 'features/modal';
import HeaderContainer from '../containers/HeaderContainer';
// Styles
import ss from './AppRoot.scss';

/**
 * Main componente when user is authenticated
 * Header above, Content below
 */
const AppRoot = ({ children }) => (
  <div className={ss.wrapper}>
    <main className={ss.main}>
      <HeaderContainer />
      {children}
    </main>
    <ModalRoot />
  </div>
);

AppRoot.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppRoot;
